<template>
  <div class="DPNGLPTable">
    <v-container grid-list-md fluid fill-height>
      <v-layout row wrap justify-center>

        <v-flex md10>
          <v-card v-if="load" class="mb-2" >
            <v-card-title class="title">
              DNP GAS - Empresas
              <v-spacer/>

              <v-card-actions>
                <v-btn color="info" :disabled="dataVals === null">
                  <download-csv
                  :data="dataVals"
                  name="Reportes Dnp Gas - Empresas.csv"
                  :labels="labels"
                  >
                  <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                </download-csv>
              </v-btn>
            </v-card-actions>
          </v-card-title>

          <v-card-text
          v-if="loading"
          class="text-xs-center"
          >
          <v-progress-circular
          :size="progressSize"
          :width="progressWidth"
          color="info"
          indeterminate
          ></v-progress-circular>
        </v-card-text>

        <v-card-text v-else>
          <data-table
          :headers="headers"
          :dataVals="dataVals"
          :items="dataVals"
          :key="tableKey"
          />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</div>
</template>

<script>
import dataTable from '@/components/Tables/TableBaseWithIcons'
import JsonCSV from 'vue-json-csv'
import moment from 'moment'

export default {
  name: 'DPNGLPTable',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
  * Esta función carga el respectivo Layout, al crear la vista.
  */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  data: function () {
    return {
      backConf: {
        path: '/projects/dnp_glp/',
        page: 1
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,
      operativo: null,


      headers: [
        { text: 'Empresas', value: 'empresa', align: 'left'  },
        { text: 'Director', value: 'direccion', align: 'left' },
        { text: 'Comercial', value: 'comercial', align: 'left' },
        { text: 'Técnico', value: 'tecnico', align: 'left' }
      ],

      dataVals: null,
      load: false,
      tableKey: 0
    }
  },

  watch: {
    operativo: function () {
      this.loadData()
    },
  },
  methods: {
    /** Carga la tabla
    */
    loadTable () {

      this.dataVals = null
      this.loading = true
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo
        }
      }
      let t = this

      this.$store.dispatch('request_back', request)
      .then(function (resp) {
        t.dataVals = resp.data
        t.loading = false
        t.tableKey += 1
      })
      .catch(function (err) {
        t.dataVals = []
        t.loading = false
        t.tableKey += 1
        console.error(err)
      })
    },

    loadData () {
      this.load = true
      this.loadTable()
    },

  }
}
</script>
